// initial state
const state = () => ({
  unread_messages_count: null,
  unseen_visitors_count: null,
  unseen_kisses_count: null,
  kisses_count: null,
  visitors_count: null,
  unseen_match_count: null
});

// getters
const getters = {
  getUserUnreadMessagesCount: state => state.unread_messages_count,
  getUserUnseenVisitorsCount: state => state.unseen_visitors_count,
  getUserUnseenKissesCount: state => state.unseen_kisses_count,
  getUserKissesCount: state => state.kisses_count,
  getUserVisitorsCount: state => state.visitors_count,
  getUnseenMatchCount: state => state.unseen_match_count,
};

// actions
const actions = {
  async fetchUserCounters({ commit }, params = {}) {
    try {
      const response = await axios.get('/ajax/user/counters', { params });
      const data = response.data.data;

      const mutationMap = {
        unread_messages: 'setUserUnreadMessagesCount',
        unseen_visitors_count: 'setUserUnseenVisitorsCount',
        unseen_kisses_count: 'setUserUnseenKissesCount',
        kisses_count: 'setUserKissesCount',
        visitors_count: 'setUserVisitorsCount',
        unseen_match_count: 'setUnseenMatchCount',
      };

      for (const [key, mutation] of Object.entries(mutationMap)) {
        if (key in data) {
          commit(mutation, data[key]);
        }
      }
    } catch (error) {
      console.error('Error fetching user counters:', error);
    }
  },
};

// mutations
const mutations = {
  setUserUnreadMessagesCount(state, count) {
    state.unread_messages_count = count;
  },
  setUserUnseenVisitorsCount(state, count) {
    state.unseen_visitors_count = count;
  },
  setUserUnseenKissesCount(state, count) {
    state.unseen_kisses_count = count;
  },
  setUserKissesCount(state, count) {
    state.kisses_count = count;
  },
  setUserVisitorsCount(state, count) {
    state.visitors_count = count;
  },
  setUnseenMatchCount(state, count) {
    state.unseen_match_count = count;
  },
  incrementUserKissesCount(state) {
    state.kisses_count = (state.kisses_count || 0) + 1;
  },
  incrementUserUnreadMessagesCount(state) {
    state.unread_messages_count = (state.unread_messages_count || 0) + 1;
  },
  incrementUserUnseenVisitorsCount(state) {
    state.unseen_visitors_count = (state.unseen_visitors_count || 0) + 1;
  },
  incrementUserUnseenKissesCount(state) {
    state.unseen_kisses_count = (state.unseen_kisses_count || 0) + 1;
  },
  incrementUserMatchCount(state) {
    state.unseen_match_count = (state.unseen_match_count || 0) + 1;
  },
  resetUserUnreadMessagesCount(state) {
    state.unread_messages_count = 0;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
